import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseProject } from '../../models/response-project';
import { ResponseProjectsListComponent } from '../response-projects-list/response-projects-list.component';
import { ResponseDocumentSubtype } from '../../models/response-document-subtype';
import { ApiResponseDocumentSubtypesService } from '../../services/api/response-document-subtypes/api-response-document-subtypes.service';
import { AuthenticationService } from '../../../shared/services/api/authentication/authentication.service';
import { TendersResponsesService } from '../../services/tenders-responses.service';

const SUBTYPE_FIELDS = ['id', 'name', 'displayed_name', 'scope'];

@Component({
  selector: 'app-tenders-responses',
  templateUrl: './tenders-responses.component.html',
  styleUrls: ['./tenders-responses.component.scss'],
})
export class TendersResponsesComponent implements OnInit {
  @ViewChild(ResponseProjectsListComponent) listComponent!: ResponseProjectsListComponent;

  activeProjectId: string | null = null;
  projects: ResponseProject[] = [];
  documentSubtypes: ResponseDocumentSubtype[] = [];
  showEmptyState = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiSubtypes: ApiResponseDocumentSubtypesService,
    private authenticationService: AuthenticationService,
    private tendersResponsesService: TendersResponsesService
  ) {}

  ngOnInit(): void {
    this.authenticationService.getAuthStatus('explain_word_addin').subscribe({
      next: status => this.tendersResponsesService.addinInstalled.set(status.connected),
    });
    this.loadSubTypes();
    this.route.firstChild?.params.subscribe(params => {
      this.activeProjectId = params['uid'] ?? null;
    });
    const uid = this.route.snapshot.firstChild?.params['uid'];
    if (uid) this.activeProjectId = uid;
  }

  private loadSubTypes(): void {
    this.apiSubtypes
      .search({
        fields: SUBTYPE_FIELDS,
        filters: {},
        limit: 100,
        offset: 0,
      })
      .subscribe({
        next: res => {
          this.documentSubtypes = res.data;
        },
      });
  }

  onProjectSelect(projectId: string): void {
    this.activeProjectId = projectId;
    this.router.navigate(['/tenders/responses', projectId]);
  }

  onProjectsLoaded(projects: ResponseProject[]): void {
    this.projects = projects;

    this.showEmptyState = projects.length <= 0;
  }
}
